import {
    ADMINGETMAPPINGBANKLISTCOMPARE_SUCCESS,
    ADMINGETMAPPINGBANKLISTCOMPARE_FAILED,
    RESET_ADMINGETMAPPINGBANKLISTCOMPARE,
    LOADING_ADMINGETMAPPINGBANKLISTCOMPARE,
    NETWORK_ERROR_ADMINGETMAPPINGBANKLISTCOMPARE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINGETMAPPINGBANKLISTCOMPARE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINGETMAPPINGBANKLISTCOMPARE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINGETMAPPINGBANKLISTCOMPARE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINGETMAPPINGBANKLISTCOMPARE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINGETMAPPINGBANKLISTCOMPARE:
            return (state = initialState);
        default:
            return state;
    }
};